import { useEffect } from "react";
import { useAnimation, motion, transform, scale } from "framer-motion";
import { useInView } from "react-intersection-observer";


const Flip = {
     visible: { transform: 'rotateX(0deg)', opacity: 1, transition: { duration: 1.2}},
    hidden: { transform: 'rotateX(-45deg)', opacity: 0.2}
};

const TransApp = {
    visible: { transform: 'translate(0px,0px)', opacity: 1, transition: { duration: 1.2}},
    hidden: { transform: 'translate(80px,0px)', opacity: 0.2}
}

export const Stretch = ({ children }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView();
    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [controls, inView]);
    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={TransApp}
            className="blk"
        >
            {children}
        </motion.div>
    );
}

export const FlipAnim = ({ children }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView();
    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [controls, inView]);
    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={Flip}
            className="blk"
        >
            {children}
        </motion.div>
    );
}